<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SubscriptionView from '../../../../../billing/components/SubscriptionView.vue'

import { Site } from '../../../../../sites/models/site.ts'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
    featureFlags: 'subscription',
  },
})

const { site } = defineProps<{
  site: Site
}>()
</script>

<template>
  <SubscriptionView :site-id="site.id" />
</template>
